import useFetch from "v4/hooks/useFetch";
import {useEffect, useMemo} from "react";
import {generateUrl} from "v4/services/api.service";
import {IMPORT_ENTITY_FIELDS} from "v4/data/apiRoutes";
import {useImportContext} from "v4/pages/admin/Import/contexts/ImportContext";

export default function useCreateImportInfo() {
    const {selectedEntityType} = useImportContext();
    const [{data, isLoading}, fetchInfo] = useFetch();
    const availableFields = useMemo(() => {
        if (!selectedEntityType || !data?.fields) return [];

        return data.fields;
    }, [data, selectedEntityType]);

    useEffect(() => {
        if (!selectedEntityType) return;

        fetchInfo({
            url: generateUrl(IMPORT_ENTITY_FIELDS, {entity: selectedEntityType}),
        });
    }, [fetchInfo, selectedEntityType]);

    return {
        selectedEntityType,
        isInfoLoading: isLoading,
        availableFields,
    }
}
